export const HERO_SCROLL_FADE_PX = 1000;

/**
 * Hero-Scroll-Blur (nur nach Intro-Handoff).
 * @param hideWhenInactive Nav-Logo ausblenden bis Handoff; Tagline/Headline: false (Opener/Framer)
 */
export function applyHeroScrollFade(
  el: HTMLElement | null,
  scrollY: number,
  active: boolean,
  hideWhenInactive = true,
) {
  if (!el) return;

  if (!active) {
    if (hideWhenInactive) {
      el.style.filter = 'none';
      el.style.opacity = '0';
    }
    return;
  }

  const progress = Math.min(1, scrollY / HERO_SCROLL_FADE_PX);
  if (progress === 0) {
    if (el.style.filter || el.style.opacity) {
      el.style.removeProperty('filter');
      el.style.removeProperty('opacity');
    }
    return;
  }
  const blur = progress * 14;
  const opacity = 1 - progress * 0.45;
  el.style.filter = `blur(${blur}px)`;
  el.style.opacity = String(opacity);
}
